import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useLoaderData, useNavigate } from 'react-router-dom';
import { HotTable } from '@handsontable/react-wrapper';
import { Button, Divider, Typography } from '@mui/material';
import useCashFlowHandsonTableConfig from '@modules/cashflow/cf-template/hooks/useCashFlowHandsonTableConfig';
import HeaderCFTemplate from '@modules/cashflow/cf-template/components/HeaderCFTemplate';
import '../styles/cf-template.css';
import useCustomTranslation from '@libs/hooks/useCustomTranslation';
var ViewCFTemplate = function () {
    var _a;
    var navigate = useNavigate();
    var cfTemplate = useLoaderData();
    var t = useCustomTranslation();
    var _b = useCashFlowHandsonTableConfig(), colWidths = _b.colWidths, contextMenu = _b.contextMenu, generateMergeCells = _b.generateMergeCells;
    var _c = generateMergeCells(((_a = cfTemplate === null || cfTemplate === void 0 ? void 0 : cfTemplate.CashflowContent) === null || _a === void 0 ? void 0 : _a.content) || []), mergeCells = _c.mergeCells, highlightedRows = _c.highlightedRows;
    var listBtns = useMemo(function () {
        return [
            _jsx(Button, { variant: 'outlined', onClick: function () { return navigate('/cashflow/cf-template'); }, children: "Close" })
        ];
    }, []);
    var content = useMemo(function () {
        if (!cfTemplate)
            return [];
        var requiredColumns = cfTemplate.CashflowContent.required.split('');
        return cfTemplate.CashflowContent.content.map(function (row, rowIndex) {
            if (rowIndex === 0) {
                return row.map(function (cell, colIndex) {
                    if (requiredColumns[colIndex] === '1') {
                        return "".concat(cell, " *");
                    }
                    return cell;
                });
            }
            return row;
        });
    }, [cfTemplate]);
    var cells = function (row, col) {
        var cellProperties = {};
        cellProperties.editor = false;
        if (highlightedRows.has(row) && col >= 1) {
            cellProperties.className = 'parent-row';
        }
        return cellProperties;
    };
    return (_jsxs("div", { className: 'table_handsome ht-theme-main flex flex-col gap-2 overflow-y-auto p-8', children: [_jsx(HeaderCFTemplate, { title: t('L000113'), listBtns: listBtns }), _jsxs("div", { className: 'flex-1 flex flex-col gap-2 bg-white rounded-lg', children: [_jsxs("div", { className: 'flex w-full px-4 py-2 items-center gap-3', children: [_jsx(Typography, { children: t('L000027') }), _jsx(Typography, { children: cfTemplate.name })] }), _jsx(Divider, { sx: {
                            height: 2
                        } }), _jsx("div", { className: 'px-4 py-2 flex-1', children: _jsx(HotTable, { width: '100%', height: '100%', data: content, contextMenu: contextMenu('create'), colWidths: colWidths, cells: cells, mergeCells: mergeCells, licenseKey: 'non-commercial-and-evaluation' }) })] })] }));
};
export default ViewCFTemplate;
